import { useCallback, useEffect, useState } from '@wordpress/element';
import { useTagsHtmlETexto } from './useManipulacaoDom';
import { select, useSelect } from '@wordpress/data';
import { useActionParam } from '@api/actions/action';

export const useAnalisesParametrosWp = ({ idPost = '0', tipo = '' }) => {
  const [parametros, setParametros] = useState(null);

  const content = useSelect(select => select('core/editor').getEditedPostContent());
  const titulo = useSelect(select => select('core/editor').getEditedPostAttribute('title'));
  const { obterTagsHtmlETextoEditorWp } = useTagsHtmlETexto();
  const { mutateAsync } = useActionParam();

  async function obterMetadados() {
    return await mutateAsync({
      action: 'buscar_meta_dados',
      param: {
        post_id: parseInt(idPost),
      },
    });
  }

  const gerarParametrosWp = useCallback(async () => {
    try {
      let seo = {};
      let metadados = null;
      const nodeList = obterTagsHtmlETextoEditorWp()?.childNodes;
      if (!nodeList) {
        console.warn('Não foi possível obter os nós do editor WordPress');
        return;
      }
      
      const htmlContainer = Array.from(nodeList).map((node, index) => ({
        html: node.innerHTML || '',
        tipo: node.getAttribute('data-type') || '',
        index,
      }));

      if (tipo.includes('textual')) {
        metadados = await obterMetadados();

        seo = {
          idArtigo: parseInt(localStorage.getItem('id_artigo_opti') ?? '0'),
          titulo: titulo,
          palavraChave: metadados?.data?.palavra_chave,
          palavrasChave: [{ palavra: metadados?.data?.palavra_chave, prioritaria: true }],
          palavraChavePrioritaria: metadados?.data?.palavra_chave,
          textoPostHtml: htmlContainer.join(''),
          url: metadados?.data?.link_permanente,
          slug: metadados?.data?.slug?.valor,
          tituloSeo: titulo,
          altImagem: metadados?.data?.alt_imagem,
          metaDescription: metadados?.data?.meta_descricao,
          headPost:
            document
              ?.getElementById('opti_preview_post')
              ?.contentWindow.document?.getElementsByTagName('head')[0]?.innerHTML ?? '',
        };
      }

      setParametros({
        html: content,
        blocos: htmlContainer,
        texto: htmlContainer
          .map(bloco => bloco.html?.replace(/<[^>]*>/g, '') || '')
          .join(' ')
          .trim(),
        ...seo,
      });
    } catch (error) {
      console.error('Erro ao processar conteúdo do editor WordPress:', error);
    }
  }, [idPost, content, titulo]);

  useEffect(() => {
    gerarParametrosWp();
  }, [gerarParametrosWp]);

  return { gerarParametrosWp, parametros };
};
